import type {HTMLAttributes} from 'react';
import classNames from 'classnames';

import styles from './attachment-card-actions.module.css';

type Props = HTMLAttributes<HTMLDivElement>;

export const AttachmentCardActions = ({children, className, ...props}: Props) => (
    <div {...props} className={classNames(styles.actions, className)}>
        {children}
    </div>
);
